// @flow
import {
    GENERAL_BASIC_INFO,
    GENERAL_BASIC_INFO_SUCCESS,
    GENERAL_BASIC_INFO_FAILED,
    GENERAL_BASIC_INFO_SAVE
} from '../../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    basicinfo: null
};

type GeneralAction = { type: string, payload: {} | string };
type State = { loading?: boolean, +value?: boolean, basicinfo?: {} | null, saving?: boolean};

const GeneralBasicInfo = (state:State = INIT_STATE, action: GeneralAction) => {
    switch (action.type) {
        case GENERAL_BASIC_INFO:
            return { ...state, loading: true };
        case GENERAL_BASIC_INFO_SAVE:
            return { ...state, saving: true };
        case GENERAL_BASIC_INFO_SUCCESS:
            return { ...state, basicinfo: action.payload, loading: false, saving: false, error: null };
        case GENERAL_BASIC_INFO_FAILED:
            return { ...state, error: action.payload, loading: false, saveing: false };
        default: return { ...state };
    }
}

export default GeneralBasicInfo;